module.exports = __webpack_public_path__ + "img/uil_calender-yellow.09c7754a.svg";